import { NgModule } from '@angular/core';
import { HighlightText } from './highlight-text.pipe';


@NgModule({
  declarations: [
    HighlightText,
  ],
  exports: [
    HighlightText,
  ],
})
export class HighlightTextModule {}
